import './App.css';
import Header from './components/Header';
import Card from './components/Card';
import travelData from './data.js';

function App() {
  const travelElements = travelData.map(item =>{
    return (
      <Card 
        key ={item.id}
        item={item}
      />

    )
  });
  return (
    <div className="App">
      <Header />
      <section className="middle-section"> 
        {travelElements}
      </section>
    </div>
  );
}

export default App;
